export const QUICK_FILTERS = 'aud_mobile_acti257_fastfilters_list_map';

export const EXPERIMENTS: string[] = [QUICK_FILTERS];
